import { Text } from "rebass";
const AlertMessage = ({ children }) => {
  return (
    <Text
      fontSize={[11, 14]}
      letterSpacing={["0", ".13em"]}
      textAlign={"center"}
      textTransform={["", "uppercase"]}
      color={["#FFFFFF", "#FFFFFF"]}
      lineHeight={["1.04"]}
    >
      {children}
    </Text>
  );
};

export default AlertMessage;
